import { TemplateNavHeaderStyles } from "./NavHeader.styles"

const t = document.createElement('template')
t.innerHTML = `
<li class="dropdown-item"><slot></slot></li>
`

class NavHeaderUtilityMenuItem extends HTMLElement {
  constructor() {
    super()

    const shadow = this.attachShadow({ mode: 'open' })
    shadow.appendChild(TemplateNavHeaderStyles.content.cloneNode(true))
    shadow.appendChild(t.content.cloneNode(true))
  }

  connectedCallback() {
    console.log('NavHeaderUtilityMenuItem connectedCallback', this)
  }
}

if (!customElements.get('ts-navheader-utility-menu-item')) {
  customElements.define('ts-navheader-utility-menu-item', NavHeaderUtilityMenuItem)
}
export { NavHeaderUtilityMenuItem }
